import type { TabItem } from '@/app/components/Tabs';
import { PERMISSION_IDS } from '@/consts/permissions';
import type { SettingsTabType } from '../types';

export const SETTINGS_TAB_QUERY_KEY = 'tab';

export const settingsTabs: TabItem[] = [
  {
    id: 'directory-info',
    label: 'Directory Info',
    permission: PERMISSION_IDS.SETTINGS_TABS_INFO,
  },
  {
    id: 'bio',
    label: 'Smartflyer.com Bio',
    permission: PERMISSION_IDS.SETTINGS_TABS_BIO,
  },
  {
    id: 'change-request',
    label: 'Request a Change',
    permission: PERMISSION_IDS.SETTINGS_TABS_REQUEST_CHANGE,
  },
  {
    id: 'admin-only',
    label: 'Admin Only',
    permission: PERMISSION_IDS.SETTINGS_TABS_ADMIN_ONLY,
  },
  {
    id: 'admin-notes',
    label: 'Admin Notes',
    permission: PERMISSION_IDS.SETTINGS_TABS_ADMIN_NOTES,
  },
  {
    id: 'notifications',
    label: 'Notifications',
    permission: PERMISSION_IDS.SETTINGS_TABS_NOTIFICATIONS,
  },
  {
    id: 'security',
    label: 'Security',
    permission: PERMISSION_IDS.SETTINGS_SECURITY,
  },
];

export const settingsTabsKeys = {
  directoryInfo: 'directory-info',
  bio: 'bio',
  changeRequest: 'change-request',
  adminOnly: 'admin-only',
  adminNotes: 'admin-notes',
  notifications: 'notifications',
  security: 'security',
} as const;

export const verifyPhoneModalsTypes = {
  verificationCodeSent: 'verification-code-sent',
  verifyedSuccessfully: 'verifyed-successfully',
} as const;

export type VerifyPhoneModalType = (typeof verifyPhoneModalsTypes)[keyof typeof verifyPhoneModalsTypes];
export const implementedTabs: SettingsTabType[] = [settingsTabsKeys.security];

export const crmSettingsTabs: Record<
  Exclude<SettingsTabType, typeof settingsTabsKeys.security>,
  string
> = {
  [settingsTabsKeys.directoryInfo]: 'directory-info-tab',
  [settingsTabsKeys.bio]: 'pills-smartflyer-bio-tab',
  [settingsTabsKeys.changeRequest]: 'pills-request-change-tab',
  [settingsTabsKeys.adminOnly]: 'pills-admin-only-tab',
  [settingsTabsKeys.adminNotes]: 'pills-admin-notes-tab',
  [settingsTabsKeys.notifications]: 'pills-notifications-tab',
};
